<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title?: string | null
    removable?: boolean
    plain?: boolean
    invert?: boolean
    disabled?: boolean
    underline?: boolean
    clickable?: boolean
  }>(),
  {
    title: '',
    removable: false,
    plain: false,
    invert: false,
    disabled: false,
    underline: true,
    clickable: true,
  }
)

const emit = defineEmits(['click', 'remove'])
</script>

<template>
  <button
    class="group/chip flex items-center justify-center self-start rounded-full px-4 py-1 text-left"
    :class="{
      'pl-4 pr-3': props.removable,
      'bg-black text-white': !props.plain && !props.invert && !props.disabled,
      'cursor-auto': props.disabled || !props.clickable,
      '!text-neutral-400': props.disabled,
      '!bg-white !text-black': props.invert,
    }"
  >
    <span
      class="h-fit text-sm"
      :class="{
        'relative after:absolute after:bottom-[2px] after:left-0 after:h-[1px] after:w-0  after:bg-black after:transition-all after:duration-500 after:ease-in-out after:content-[\'\'] hover:after:w-full group-hover/chip:after:w-full group-hover:after:w-full':
          props.underline && !props.disabled,
        'after:bg-white':
          props.underline && !props.disabled && !(props.invert || props.plain),
      }"
      @click="
        () => {
          if (props.clickable && !props.disabled) {
            emit('click')
          }
        }
      "
    >
      {{ props.title || '' }}
    </span>
    <IconClose
      v-if="props.removable && !props.disabled"
      class="my-auto ml-2 cursor-pointer !text-white"
      :invert="!props.invert && !props.plain"
      @click.stop="emit('remove')"
    />
  </button>
</template>
